import React, { forwardRef } from 'react';

import { MASK_OPTIONS } from '@vlabs/api-bindings/src/constants';
import { ControllableOptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { useFormContext } from 'react-hook-form';

import st from '../popovers.module.sass';

function MasksFilterPopover(
  {
    name = 'masks',
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { control } = useFormContext();

  return (
    <FilterPopover
      {...props}
      name={name}
      ref={ref}
    >
      <ControllableOptionsFilter
        control={control}
        isSearchable={false}
        name={name}
        options={MASK_OPTIONS.raw}
      />
      <div className={st.Divider} />
    </FilterPopover>
  );
}

const MasksFilterPopoverWithRef = forwardRef(MasksFilterPopover);
export { MasksFilterPopoverWithRef as MasksFilterPopover };
